import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ENV } from '@/configurations/env';
import { IconLogo } from '@agentguru/components';
import styles from './AppAgencyRoute.module.scss';
export function AppAgencyRoute() {
    return (_jsxs("button", { type: "button", className: styles.container, onClick: function () { return window.open(ENV.APP_URL, '_blank'); }, children: [_jsx(IconLogo, { variant: "agentGuruDark" }), _jsx("i", { className: "icon-ag-external-link" })] }));
}
